import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: theme.palette.background.default,
  },
  toggle: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 8,
    paddingBottom: 8,
    height: 26,
    borderRadius: 32,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#C4C6C9',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    fontSize: 16,
    fontFamily: 'Poppins',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  },
  toggleSelected: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  item: {
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 14,
    fontFamily: 'Poppins',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
}));
